import { Component, Prop, Vue } from "vue-property-decorator";
import * as tsx from "vue-tsx-support";

import {
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from "@/lib/typed-bootstrap";

import { emailFormatter, isValidEmailAddress } from "@/utils";

@Component
export default class FormEmail extends Vue {
  _tsx!: tsx.DeclareProps<{
    value: FormEmail["value"];
    placeholderText: FormEmail["placeholderText"];
    shouldValidate?: FormEmail["shouldValidate"];
    isDisabled?: FormEmail["isDisabled"];
    label?: FormEmail["label"];
    autocompleteType?: FormEmail["autocompleteType"];
    required?: FormEmail["required"];
  }> &
    tsx.DeclareOnEvents<{
      onInput: string;
    }>;

  @Prop({ required: true }) value!: string;
  @Prop({ required: true }) readonly placeholderText!: string;
  @Prop({ default: false }) readonly shouldValidate!: boolean;
  @Prop({ default: false }) readonly isDisabled!: boolean;
  @Prop() readonly label!: string;
  @Prop({ default: "username" }) readonly autocompleteType!: string;
  @Prop({ default: true }) readonly required: boolean = true;

  get formLabel(): string {
    return this.label ?? this.$t("global_email").toString();
  }

  get internalValue(): string {
    return this.value;
  }

  set internalValue(email: string) {
    this.$emit("input", email);
  }

  get isValidEmailAddress(): boolean | null {
    return this.internalValue?.length > 0
      ? isValidEmailAddress(this.internalValue)
      : null;
  }

  inputFormatter(value: string): string {
    return emailFormatter(value);
  }

  render() {
    return (
      <BFormGroup
        id="emailInputGroup"
        class="default__form-group uppercase"
        label={this.formLabel}
        labelFor="emailInput"
      >
        <BFormInput
          type="email"
          id="emailInput"
          class="default__form-input"
          data-testid="emailInput"
          disabled={this.isDisabled}
          placeholder={this.placeholderText}
          value={this.internalValue}
          onInput={(val: string | number) =>
            (this.internalValue = val.toString())
          }
          state={this.shouldValidate ? this.isValidEmailAddress : null}
          autocomplete={this.autocompleteType}
          maxLength={254}
          required={this.required}
          formatter={this.inputFormatter}
          trim
        />

        {this.shouldValidate && (
          <BFormInvalidFeedback
            state={this.isValidEmailAddress}
            class="default__form-annotation"
          >
            {this.$t("global_email_error_format_email")}
          </BFormInvalidFeedback>
        )}
      </BFormGroup>
    );
  }
}
